import { useManager, useResource } from '@/hooks'
import { Box, Container, Typography } from '@mui/joy'

import i18n from '@/i18n'
import { formatHTML } from '@/utils'

export function GuidesPage() {
    const manager = useManager()

    const { data: docs } = useResource({
        queryKey: ['docs'],
        path: `/docs`
    })

    return (
        <Container>
            <Typography level="h1" component="h1">{i18n.t('guides')}</Typography>
            <Box sx={{ display: 'grid', gap: 1,  gridTemplateColumns: '1fr 1fr' }}> 
                {(manager?.label?.slug === 'gozzirecords' || manager?.slug === 'gozzirecords' || manager?.organization?.slug === 'gozzirecords') && (
                    <div dangerouslySetInnerHTML={{ __html: formatHTML("https://www.youtube.com/watch?v=3wFH3BLBtGs")}} />
                )}
                {/*docs?.results?.map(doc => (
                    <FeatureCard   
                        key={doc.id} 
                        as={Link}
                        to={doc.id}
                        Icon={Books}
                        name={doc.name}
                        description={doc.summary}
                    />
                ))*/}
            </Box>
        </Container>
    )
}